import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { EmailPasswordLoginRequest } from '../../../../requests/email-password-login-request';
import { CommonModule } from '@angular/common';
import { AuthenticationService } from '../../../../services/auth/authentication.service';
import { QrCodeResponse } from '../../../../responses/qr-code-response';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-email-password',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './email-password.component.html',
  styleUrl: './email-password.component.scss'
})
export class EmailPasswordComponent {
  form!: FormGroup;
  error?: string;
  loading: boolean = false;

  @Output()
  loginEmitter: EventEmitter<QrCodeResponse> = new EventEmitter();

  constructor(private fb: FormBuilder, private router: Router, private authService: AuthenticationService) {
    this.form = fb.group({
      email: fb.control('', [Validators.required, Validators.email]),
      password: fb.control('',[Validators.required, Validators.min(8)])
    });
  }

  public login() : void {
    if(this.form.valid) {
      this.loading = true;
      this.error = undefined;
      let currentRequest : EmailPasswordLoginRequest = this.form.value;

      this.authService.loginWithEmailPassword(currentRequest)
        .subscribe({
          next: (response: QrCodeResponse) => {
            this.loginEmitter.emit(response);
            this.loading = false;
          },
          error: (response: HttpErrorResponse) => {
            this.error = response.error.message;
            this.loading = false;
          }
        });
    } else {
      this.error = 'Invalid email or password!';
    }
  }
}
